import {Injectable} from '@angular/core';



import {isIos} from '../../../utils/platform.utils';
import {NativeModule} from '../native.module';



@Injectable({
  providedIn: NativeModule
})
export class StatusbarService {

  async changeStatusBar( style : any , iosOnly: boolean = false): Promise<void> {
    return;
  }

  changeBgColor(color: string): Promise<void> {
    return ;
  }

  hideStatusBar(): Promise<void> {
    return ;
  }

  showStatusBar(): Promise<void> {
    return ;
  }
}
